import { styled } from '@mui/material/styles';

const StyledFooterLogo = styled('img')`
  max-width: 6rem;
  min-width: 4rem;
  &:hover {
    cursor: pointer;
  }
`;

const FooterLogo = () => (
  <StyledFooterLogo src="https://trinitylifesciences.com/wp-content/uploads/2025/09/trinity-logo.svg" alt="Trinity Logo" />
);

export default FooterLogo;
